import React, { useState } from "react";
import axios from "axios";
import { HashLink } from "react-router-hash-link";

function SuggesstionForm({ AfterSubmitAction }) {
  const [formData, setFormData] = useState({
    fullName: "",
    subject: "",
    message: "",
  });

  const onSubmitForm = (e) => {
    e.preventDefault();
    sendSuggMail();
  };

  const sendSuggMail = async () => {
    var data = {
      fullName: formData.fullName,
      subject: formData.subject,
      message: formData.message,
    };

    axios.post("server/sendSuggMail.php", data).then(function (response) {
      AfterSubmitAction(true);
    });
  };

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <form data-type="suggesstion" onSubmit={onSubmitForm}>
      <h1 className="form-header">Themenvorschlag</h1>
      <div className="form-control">
        <label htmlFor="fullName" className="form-label">
          Name (optional)
        </label>
        <input
          className="form-input"
          onChange={handleChange}
          type="text"
          name="fullName"
        />
      </div>

      <div className="form-control">
        <label htmlFor="subject" className="form-label">
          Betreff
        </label>
        <input
          className="form-input"
          onChange={handleChange}
          type="text"
          name="subject"
          required
        />
      </div>

      <div className="form-control">
        <label htmlFor="message" className="form-label">
          Vorschlag
        </label>
        <textarea
          className="form-input"
          onChange={handleChange}
          type="text"
          name="message"
          required
        />
      </div>
      <div className="form-control">
        <span className="form-control-info">
          <input
            type="checkbox"
            placeholder="Datenschutz"
            required
            name="datenschutz"
          />
          Ich willige in die in der{" "}
          <HashLink to="/datenschutz">Datenschutzerklärung</HashLink>{" "}
          beschriebene Verarbeitung meiner Daten ein: <span>*</span>
        </span>
      </div>
      <button type="submit" className="btn">
        Absenden
      </button>
    </form>
  );
}

export default SuggesstionForm;
